import * as React from "react";
import Select from "react-select";
import { ContactShape } from "@eave/shared/types/api";

interface ContactProps {
  options?: ContactShape[];
  selectableField?: string;
  setFields?: Function;

  data: ContactShape;
  fields: any[];
  role: string;
  contact_role_enum: string;
  handleOnChange: Function;
}

export default class Contact extends React.Component<ContactProps, any> {
  constructor(props) {
    super(props);

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleSelectChange(e) {
    const { contact_role_enum, role, options, selectableField, fields, setFields } = this.props;

    // find which option was selected
    let selectedOption = null;
    // e === null when the operator clicks the "x" to deselect the current option
    if (e !== null) {
      const matchingOptions = options.filter(o => o[selectableField] === e.value);
      // there should be exactly 1 matching option
      if (matchingOptions.length === 1) {
        selectedOption = matchingOptions[0];
      }
    }

    // set all fields to the value of the same field on selectedOption
    setFields(contact_role_enum, role, selectedOption);
  }

  handleOnChange(e) {
    const { handleOnChange, contact_role_enum } = this.props;
    handleOnChange(contact_role_enum, e);
  }

  // the value of the selectable field for all options
  selectableFieldOptions() {
    const { options, selectableField } = this.props;
    return options.map(o => {
      const value = o[selectableField];
      return {
        label: value,
        value,
      };
    });
  }

  // the value of the selectable field for the currently selected option
  selectableFieldSelectedOption() {
    const { data, selectableField } = this.props;

    let selectedOption = null;
    if (data && data[selectableField]) {
      const value = data[selectableField];
      selectedOption = {
        label: value,
        value,
      };
    }

    return selectedOption;
  }

  render() {
    const {
      options,
      selectableField,
      setFields,
      fields,
      data,
      role,
      contact_role_enum,
    } = this.props;

    return (
      <ul>
        {fields.map((field, index) => {
          // options, setFields, and selectableField are required if this contact
          // is selectable from a list of options
          if (options && setFields && selectableField && field.name === selectableField) {
            return (
              <li key={index}>
                <Select
                  clearable
                  placeholder="select a contact"
                  value={this.selectableFieldSelectedOption()}
                  options={this.selectableFieldOptions()}
                  onChange={this.handleSelectChange}
                />
              </li>
            );
          }

          // default
          return (
            <li key={index}>
              <input
                type="text"
                name={`${role}-${field.name}`}
                value={(data && data[field.name]) || ""}
                onChange={this.handleOnChange}
                readOnly={field.readonly === true}
              />
            </li>
          );
        })}
      </ul>
    );
  }
}
